'use client';

import React, { useState } from 'react';
import ProductDetailsModal from './ProductDetailsModal';

interface OfferModalTriggerProps {
  product: any;
  merchantName: string;
  merchantLogo: string;
  domain: string;
  children: React.ReactNode;
  className?: string;
}

const OfferModalTrigger = ({ product, merchantName, merchantLogo, domain, children, className }: OfferModalTriggerProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsModalOpen(true);
        }}
        className={className ?? "text-left cursor-pointer"}
      >
        {children}
      </button>

      {isModalOpen && (
        <ProductDetailsModal
          product={product}
          merchantName={merchantName}
          merchantLogo={merchantLogo}
          domain={domain}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default OfferModalTrigger;
